/* import __COLOCATED_TEMPLATE__ from './tag-drop-header.hbs'; */
import ComboBoxSelectBoxHeaderComponent from "select-kit/components/combo-box/combo-box-header";
export default ComboBoxSelectBoxHeaderComponent.extend({
  classNames: "tag-drop-header"
});